import { Modal, Row, Tabs } from 'antd'
import React, { useState } from 'react'
import Image from '../Image'
import HeroFollower from '../HeroFollower'
import HeroFollowing from '../HeroFollowing'
import HeroDocument from '../Document'
import HeroCoin from '../Coin'
import HeroForm from '../HeroForm'
import HeroProducts from '../HeroProducts'
import LocationForm from '../LocationForm'
import LocationMap from '../PickLocation'
import { useDeepEffect } from '../../../../utils/hooks'
import _, { isEmpty } from 'lodash'
import HeroBin from '../HeroBin'
import { useDispatch, useSelector } from 'react-redux'
import { fetchLocationByHero } from '../../../../modules/location'
import { getHeroDetail, saveHeroLocation } from '../../../../modules/hero'

export const HeroModal = ({
  heroConfigs,
  formData,
  statusOptions,
  heroTypeOptions,
  visible,
  onClose,
  onOk
}) => {
  const dispatch = useDispatch()
  const [heroConfig, setHeroConfig] = useState(null)

  const { locationList, heroDetail } = useSelector(
    (state) => ({
      locationList: state.location.locationList,
      heroDetail: state.hero.heroDetail
    }),
    []
  )

  async function fetch() {
    await dispatch(fetchLocationByHero(formData.id))
    await dispatch(getHeroDetail(formData.id))
  }

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      fetch()
    }
  }, [formData])

  useDeepEffect(() => {
    if (formData) {
      const config = _.find(heroConfigs, (item) => {
        return item.heroType === formData.heroType
      })
      setHeroConfig(config)
    }
  }, [formData])

  async function onSaveLocation(data) {
    await dispatch(saveHeroLocation(data))
    await dispatch(fetchLocationByHero(formData.id))
  }

  return (
    <Modal
      footer={null}
      visible={visible}
      title={!isEmpty(formData) ? 'Edit hero' : 'Create a new hero'}
      onCancel={onClose}
      destroyOnClose={true}
      width={1000}>
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab="Hero Profile" key="1">
          <HeroForm
            onOk={onOk}
            data={formData}
            statusOptions={statusOptions}
            heroTypeOptions={heroTypeOptions}
          />
        </Tabs.TabPane>
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="Hero Locations" key="2">
            {locationList && locationList.length > 0 && (
              <LocationMap
                draggable={false}
                hero={heroDetail}
                locationList={locationList}
                heroConfigs={heroConfigs}
              />
            )}
            {!isEmpty(formData) && (
              <Row type="flex" gutter={8}>
                <LocationForm
                  onSaveLocation={onSaveLocation}
                  locationList={locationList}
                  hero={heroDetail}
                  onClose={onClose}
                  heroConfig={heroConfig}
                />
              </Row>
            )}
          </Tabs.TabPane>
        )}
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="Image" key="3">
            <Image data={heroDetail} />
          </Tabs.TabPane>
        )}
        {!isEmpty(formData) &&
          (formData.heroType !== 'CIRCULAR_BIN' ? (
            <Tabs.TabPane tab="Products" key="4">
              <HeroProducts hero={formData} />
            </Tabs.TabPane>
          ) : (
            <Tabs.TabPane tab="Bin" key="4">
              <HeroBin hero={formData} />
            </Tabs.TabPane>
          ))}
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="Documents" key="5">
            <HeroDocument data={heroDetail} />
          </Tabs.TabPane>
        )}
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="Coins" key="6">
            <HeroCoin data={heroDetail} />
          </Tabs.TabPane>
        )}
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="คู่ค้า" key="7">
            <HeroFollowing data={heroDetail} />
          </Tabs.TabPane>
        )}
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="ลูกค้า" key="8">
            <HeroFollower data={heroDetail} />
          </Tabs.TabPane>
        )}
      </Tabs>
    </Modal>
  )
}

export default HeroModal



// WEBPACK FOOTER //
// ./src/pages/Heroes/components/HeroModal/index.js